import { DEFAULTS } from './';

export const RATE = [
  0.5,
  0.6,
  0.7,
  0.8,
  0.9,
  DEFAULTS.RATE,
  1.1,
  1.2,
  1.3,
  1.4,
  1.5,
  1.6,
  1.7,
  1.8,
  1.9,
  2,
  2.1,
  2.2,
  2.3,
  2.4,
  2.5,
  2.6,
  2.7,
  2.8,
  2.9,
  3,
  3.1,
  3.2,
  3.3,
  3.4,
  3.5,
  3.6,
  3.7,
  3.8,
  3.9,
  4,
];

export const MARKS = [
  {
    value: 0.5,
    label: '0.5x',
  },
  {
    value: 4,
    label: '4.0x',
  },
];
